function CalenderIcon() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3125 12.6059C1.3125 8.1393 1.3125 5.90603 2.70008 4.51844C4.08767 3.13086 6.32094 3.13086 10.7875 3.13086H15.525C19.9915 3.13086 22.2249 3.13086 23.6124 4.51844C25 5.90603 25 8.1393 25 12.6059V14.9746C25 19.4411 25 21.6745 23.6124 23.062C22.2249 24.4496 19.9915 24.4496 15.525 24.4496H10.7875C6.32094 24.4496 4.08767 24.4496 2.70008 23.062C1.3125 21.6745 1.3125 19.4411 1.3125 14.9746V12.6059Z"
        stroke="#AAA5A5"
        stroke-width="1.3"
      />
      <path
        d="M7.23438 3.13105V1.35449"
        stroke="#AAA5A5"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M19.0781 3.13105V1.35449"
        stroke="#AAA5A5"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M1.90466 9.05273H24.4078"
        stroke="#AAA5A5"
        stroke-width="1.3"
        stroke-linecap="round"
      />
      <path
        d="M20.2625 18.5281C20.2625 19.1823 19.7323 19.7125 19.0782 19.7125C18.424 19.7125 17.8938 19.1823 17.8938 18.5281C17.8938 17.874 18.424 17.3438 19.0782 17.3438C19.7323 17.3438 20.2625 17.874 20.2625 18.5281Z"
        fill="#AAA5A5"
      />
      <path
        d="M20.2625 13.7903C20.2625 14.4445 19.7323 14.9747 19.0782 14.9747C18.424 14.9747 17.8938 14.4445 17.8938 13.7903C17.8938 13.1362 18.424 12.606 19.0782 12.606C19.7323 12.606 20.2625 13.1362 20.2625 13.7903Z"
        fill="#AAA5A5"
      />
      <path
        d="M14.3407 18.5281C14.3407 19.1823 13.8104 19.7125 13.1563 19.7125C12.5022 19.7125 11.9719 19.1823 11.9719 18.5281C11.9719 17.874 12.5022 17.3438 13.1563 17.3438C13.8104 17.3438 14.3407 17.874 14.3407 18.5281Z"
        fill="#AAA5A5"
      />
      <path
        d="M14.3407 13.7903C14.3407 14.4445 13.8104 14.9747 13.1563 14.9747C12.5022 14.9747 11.9719 14.4445 11.9719 13.7903C11.9719 13.1362 12.5022 12.606 13.1563 12.606C13.8104 12.606 14.3407 13.1362 14.3407 13.7903Z"
        fill="#AAA5A5"
      />
      <path
        d="M8.4188 18.5281C8.4188 19.1823 7.88853 19.7125 7.23442 19.7125C6.58032 19.7125 6.05005 19.1823 6.05005 18.5281C6.05005 17.874 6.58032 17.3438 7.23442 17.3438C7.88853 17.3438 8.4188 17.874 8.4188 18.5281Z"
        fill="#AAA5A5"
      />
      <path
        d="M8.4188 13.7903C8.4188 14.4445 7.88853 14.9747 7.23442 14.9747C6.58032 14.9747 6.05005 14.4445 6.05005 13.7903C6.05005 13.1362 6.58032 12.606 7.23442 12.606C7.88853 12.606 8.4188 13.1362 8.4188 13.7903Z"
        fill="#AAA5A5"
      />
    </svg>
  );
}

export default CalenderIcon;
